import {
	RESET
} from 'redux/constants/main';

export function reset () {
	return {
		type: RESET
	};
}
